<template>
  <div class="section">
     <h1 class="title">
      Your discover ebooks
    </h1>
    <chunked-ebooks-display :ebooks="discoverEbooks"/>
  </div>
</template>

<script>
import chunkedEbooksDisplay from '@/components/chunked-ebooks-display'

export default {
  name: 'UserDiscoverEbooksList',
  created () {
    this.$store.dispatch('getUserDiscoverEbooks')
  },
  computed: {
    discoverEbooks () {
      return this.$store.getters.getUserDiscoverEbooksList
    }
  },
  components: {
    chunkedEbooksDisplay
  }
}
</script>

<style>

</style>
